<script>
import appConfig from "@/app.config";
import LocalInvoicesApi from "@/services/local-invoices-api";
import Swal from "sweetalert2";


export default {
  page: {
    title: "Facture",
    meta: [{ name: "description", content: appConfig.description }]
  },

  props: {
    localInvoiceId: {
      type: Number,
      default: 0,
    },
    isCatalogList: {
      type: Boolean,
      default: false,
    },
    showTransfer:{
      type: Boolean,
      default:null
    }
  },

  watch: {
      'localInvoiceId': function(){
        this.getLocalInvoice();
    }
  },

  components: { },
  data() {
    return {
        
      localInvoice: {lines:[], supplier:{city:{}, country:{}}, customer:{city:{}, country:{}},},
      role: null,
        
    };
  },  
  
    mounted() {
    
    this.getLocalInvoice();
    this.role=sessionStorage.getItem("userr");

  },

    methods: {

      cancelLocalInvoice() {
      Swal.fire({
        title: "Annuler la facture ?",
        html: this.localInvoice.ref,
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, Annuler !",

      })
      
      .then(result => {

        const  localInvoice= {
        invoiceId : this.localInvoiceId, 
        customerId: this.localInvoice.customer.id,
        supplierId: this.localInvoice.supplier.id,
      }
        if (result.value) {
          LocalInvoicesApi.cancelLocalInvoice(localInvoice)
            .then((localInvoice) => {
              if (localInvoice) {
                this.localInvoice = localInvoice;
                this.$router.push({ path: '/newLocalInvoice', query: {  localInvoiceId: this.localInvoiceId } });

              }
            })
        }
      });
    },

    mergeLocalInvoice() {
      Swal.fire({
        title: "Fusionner avec la facture précédente ?",
        html: this.localInvoice.ref,
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, Fusionner !",

      })
      
      .then(result => {

        const  localInvoice= {
        invoiceId : this.localInvoiceId, 
        customerId: this.localInvoice.customer.id,
        supplierId: this.localInvoice.supplier.id,
      }
        if (result.value) {
          LocalInvoicesApi.mergeLocalInvoice(localInvoice)
            .then((localInvoiceId) => {
              if (localInvoiceId) {
                this.$router.push({ path: '/local-invoices/get', query: {  localInvoiceId: localInvoiceId } });

              }
            })
        }
      });
    },

    validerLocalInvoice() {
      Swal.fire({
        title: "Valider la facture ?",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, Annuler !",

      })
      
      .then(result => {
        const  localInvoice= {
        invoiceId : this.localInvoiceId, 
        customerId: this.localInvoice.customer.id,
        supplierId: this.localInvoice.supplier.id,
      }
        if (result.value) {
          LocalInvoicesApi.submitLocalInvoice(localInvoice)
            .then((localInvoice) => {
              if (localInvoice) {
                this.localInvoice = localInvoice;
                this.deliveryMode = this.getDeliverMode(this.localInvoice);
              }
            })
        }
      });
    },

      shareInvoiceWithCustomer(localInvoice) {
      if (!localInvoice) {
        return;
      }
      Swal.fire({
                  title: "Partager avec le client ?",
                  html: 'Envoyer la facture ' + localInvoice.ref + ' au client ?',
                  icon: "info",
                  showCancelButton: true,
                  confirmButtonColor: "#34c38f",
                  cancelButtonColor: "#f46a6a",
                  cancelButtonText: "Non, plus tard",
                  confirmButtonText: "Oui, envoyer!"
              }).then(result=>{
                if(result.value){
                  LocalInvoicesApi.shareWithCustomer(localInvoice.id);
                  }
                  })
    },

    downloadWithHolding(localInvoiceId,localInvoiceRef ){
      LocalInvoicesApi.getWithHolding(localInvoiceId, localInvoiceRef)
  
    },
  

    getLocalInvoice() {

      LocalInvoicesApi.get(this.localInvoiceId)
      .then(localInvoice => {
        this.localInvoice = localInvoice;
      })

      .finally(() => {
      })
    },

    statusToLabel(localInvoice) {
      if (localInvoice == null || localInvoice.status == null) {
        return '';
      }

      switch(localInvoice.status) {
        case 0: return 'Brouillon';
        case 1: return 'Nouvelle';
        case 2: return 'Valide'
        case 3: return localInvoice.isDeliveryDone ? 'Livré' : 'En cours de Livraison';
        case 4: return 'Annulée';
        default: return '';
      }
    },

    statusToColor(localInvoice) {
      switch(localInvoice.status) {
        case 0: return 'secondary';
        case 1: return 'danger';
        case 2: return 'info';
        case 3: return localInvoice.isDeliveryDone ? 'success' : 'info';
        case 4: return 'secondary';
        default: return 'black';
      }
    },

   
  }

}

</script>

<style>
.modal-dialog.modal-xl {
    min-width: 95% !important;
    min-height: 95% !important;
}

@media print {
    .no-border-on-print {
        border: none !important;
    }
}

</style>

<template>
<div>
    <div class="row pt-4  d-print-none">
      

      <div class="col-md-6 col-sm-12 text-left " >
        <div class="form-group mb-3">
          <label>Etat de la facture</label><br>

          <h5><b-badge href="#" :variant="statusToColor(localInvoice)">{{statusToLabel(localInvoice)}}</b-badge></h5>
         
        </div>
      </div>

     <div class="col-md-6 col-sm-12 text-right ">
        
      </div>

      <div class="col-md-2 col-sm-12 p-1 text-right d-print-none">
      </div>

    </div>

    
    
   
    <div class="row " >

      
      
      <div class="col-12">

        
        <div class="card border border-info no-border-on-print">
          <div class="card-body">
            <div  class="invoice-title">
              <h4 class="float-right text-primary font-size-16">Facture N° <strong>{{localInvoice.ref}}</strong></h4>
              <!-- <div v-if="localInvoice.supplier.logo != null " class="mb-4"> -->
                <img v-bind:src="'/api/image/get/' + localInvoice.supplier.logo    " alt="logo" height="40" />

              <!-- </div> -->
            </div>
            <hr class="d-print-none" />
            <div class="row">
              <div  class="col-6">
                <address>
                  <strong>Fournisseur :</strong> {{this.localInvoice.supplier.legalName}}
                  <br />{{this.localInvoice.supplier.address}}
                  <br />{{this.localInvoice.supplier.city.name}}, {{this.localInvoice.supplier.country.name}}
                  <br /><i>{{this.localInvoice.supplier.taxRefNumber ? 'MF : ' + this.localInvoice.supplier.taxRefNumber : ''}} </i>
                  <br/><br /><i v-if="localInvoice.supplier.phone" class="fas fa-phone text-muted font-size-12"/> {{this.localInvoice.supplier.phone}}
                  <span v-if="localInvoice.supplier.secondPhone" class="font-size-12"> - {{this.localInvoice.supplier.secondPhone}}</span>
                  
                  <br />
                </address>
              </div>
              <div class="col-6 text-right">
                <address>
                  <strong>Client :</strong> {{this.localInvoice.customer.name}}
                  <br />{{this.localInvoice.customer.city.name}} - {{this.localInvoice.customer.country.name}}
                  <br /><i>{{this.localInvoice.customer.taxRefNumber ? 'MF : ' + this.localInvoice.customer.taxRefNumber : ''}} </i>
                  <br/><br /><i v-if="localInvoice.customer.phone" class="fas fa-phone text-muted font-size-12"/> {{this.localInvoice.customer.phone}}
                  <span v-if="localInvoice.customer.secondPhone" class="font-size-12"> - {{this.localInvoice.customer.secondPhone}}</span>
                </address>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-3">
                <address>
                  <strong>Date:</strong>
                  <br />{{localInvoice.submissionDate}}
                  
                </address>
              </div>
              <div class="col-6 mt-3 text-right">
                <address>
    
                </address>
              </div>
            </div>
            <address>
                  <strong>Date d'Echeance:</strong>
                  <br />{{this.localInvoice.dueDate}}
                  </address>
  
            <div class="p-2 mt-3">
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-primary" style="width: 150px;">Référence</th>
                    <th class="text-primary" style="width: 300px;">Article</th>
                    <th style="width: 250px;" class="text-right text-primary">P.U.</th>
                    <th style="width: 250px;" class="text-right text-primary">P.U. Remisé</th>
                    <th style="width: 120px;" class="text-right text-primary">Quantité</th>
                    <th style="width: 250px;" class="text-right text-primary">Prix HT</th>
                    <th style="width: 100px;" class="text-right text-primary">Remise %</th>
                    <th style="width: 250px;" class="text-right text-primary">Prix HT Remisé (TND)</th>
                  </tr>
                </thead>
                <tbody>
                  
                     <tr v-for="(line,i) in this.localInvoice.lines" :key="i">
                      <td>{{ line.ref }}</td> 
                      <td>{{ line.itemTitle }}
                        <p v-if="line.description" class="m-0 pt-1 text-muted font-size-12"><i> {{ line.description }} </i></p>

                      </td> 
                      
                     
                      <td class="text-right">{{ line.price }}</td>
                      <td class="text-right">{{ line.discountedPrice }}</td>
                      <td class="text-right">{{ line.quantity }}</td>
               
                        <td class="text-right">{{ line.lineTotalAmountBeforeDiscountStr }}</td>

                      <td class="text-right">{{ line.discountRate == 0 ? '' : line.discountRateStr + ' %' }} </td>

                       <!-- TODO ce calcul doit etre faut du cote serveur ou avec le bon nombre de chiffres apres la virgule -->
                      <td class="text-right">{{ line.lineTotalAmount }}</td>
                    </tr>
               
                  <tr>
                    <td colspan="7" class="border-1 text-right pt-4">
                      <strong>Total Remise</strong>
                    </td>
                    <td class="border-1 text-right pt-4">
                       <span class="m-0">{{this.localInvoice.discountAmount}} TND</span>
                    </td>
                  </tr>

                   <tr>
                    <td colspan="7" class="border-0 text-right">
                      <h5 class="m-0">Total HT</h5>
                    </td>
                    <td class="border-0 text-right">
                      <h5 class="m-0">{{this.localInvoice.total}} TND</h5>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="7" class="border-0 text-right">
                      <strong>Taxes</strong>
                    </td>
                    <td class="border-0 text-right">
                      <span class="m-0">{{this.localInvoice.taxes}} TND</span>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="7" class="border-0 text-right">
                      <strong>T.V.A.</strong>
                    </td>
                    <td class="border-0 text-right">
                      <span class="m-0">{{this.localInvoice.vat}} TND</span>
                    </td>
                  </tr>

                <tr v-if=" localInvoice.isTaxStampEnabled">
                  <td colspan="7" class="border-0 text-right">
                    <strong>Timbre Fiscal</strong>
                  </td>
                  <td class="border-0 text-right">
                    <span class="m-0">{{localInvoice.taxStamp}} TND</span>
                  </td>
                </tr>

                  <tr>
                    <td colspan="7" class="border-0 text-right">
                      <h5 class="m-0">Total TTC</h5>
                    </td>
                    <td class="border-0 text-right">
                      <h5 class="m-0">{{this.localInvoice.totalWithTaxes}} TND</h5>
                    </td>
                  </tr>

                </tbody>
              </table>

              <div v-if="localInvoice.message" class="row" >
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-1 mt-4 pb-0 pl-0" style="border-top:1px solid #cccfd4;" >
                    <h4 class="card-title mb-1">Commentaire du client</h4>
                    <p class="text-muted mb-0" >
                            {{this.localInvoice.message }} </p>

                    
              </div>
              </div>

            </div>
           
          </div>
    </div>
          <div class="row pt-4 pb-4" >
              
              <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" > 
                <a href="javascript:window.print()">
                    <b-button variant="light" style="width: 100%" size="lg" v-if="!isCatalogList" >
                          <i class="fa fa-print font-size-16 align-middle mr-2"></i> Imprimer
                    </b-button>
                  </a>
              </div>

              <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" > 
                  <b-button variant="light" style="width: 100%" size="lg" @click.prevent="downloadWithHolding(localInvoiceId ,localInvoice.ref)"  v-if="!isCatalogList" >
                        <i class="fas fa-file-pdf font-size-16 align-middle mr-2"></i> Télécharger
                  </b-button>
              </div>
              <!-- <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" > 
                <a v-if="false" href="javascript: void(0);">
                    <b-button variant="light" style="width: 100%" size="lg" >
                    </b-button>
                  </a>
              </div>  
              <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" > 
                <a v-if="false" href="javascript: void(0);">
                    <b-button variant="light" style="width: 100%" size="lg" >
                    </b-button>
                  </a>
              </div>   -->

              <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" /> 

              <div v-if="localInvoice.status == 4"  class="col-md-2 col-sm-4 p-1 text-right position-right d-print-none"> </div>


              <div class="col-md-2 col-sm-4 p-1 text-right position-right d-print-none" > 
                <b-button variant="info" style="width: 100%" size="lg" @click="shareInvoiceWithCustomer(localInvoice)" >
                        <i class="fas fa-share-alt font-size-16 align-middle mr-2"></i> Partager
                    </b-button>
              </div>

              <div v-if="localInvoice.status == 0" class="col-md-2 col-sm-4 p-1 text-right position-right d-print-none">
                <b-button variant="success" style="width: 100%" size="lg" @click="validerLocalInvoice"  >
                        <i class="fas fa-check font-size-16 align-middle mr-2"></i> Valider
                    </b-button>
              </div>
              
              <div v-if="localInvoice.status == 2" class="col-md-2 col-sm-4 p-1 text-right position-right d-print-none">

                  <b-button variant="warning" style="width: 100%" size="lg" @click="mergeLocalInvoice"  >
                        <i class="fas fa-times font-size-16 align-middle mr-2"></i> Fusionner
                    </b-button>

              </div>

              <div v-if="localInvoice.status == 2" class="col-md-2 col-sm-4 p-1 text-right position-right d-print-none">


<b-button variant="danger" style="width: 100%" size="lg" @click="cancelLocalInvoice"  >
      <i class="fas fa-times font-size-16 align-middle mr-2"></i> Annuler
  </b-button>
</div>


            </div>
    </div>

    </div>

</div>
</template>